<div class="hmf-display-flex hmf-flex-wrap hmf-justify-content-center">
  @for (techIcons of techIconsArray; track trackByFn($index, techIcons)) {
    <div class="tech-icons hmf-col hmf-span-sm-12 hmf-span-md-6 hmf-span-lg-3">
      <div class="hmf-display-flex hmf-justify-content-center hmf-align-items-center">
        @if (techIcons?.image || techIcons?.visualAssets || techIcons?.youtubeId || techIcons?.animation) {
          <shared-media-component-media
            class="tech-icons-img"
            [visualAssets]="techIcons?.visualAssets"
            [altText]="techIcons?.altText"
            [image]="techIcons?.image"
            [mobileImg]="techIcons?.mobileImg"
            [itemTitle]="techIcons?.headline"
            [youtubeId]="techIcons?.youtubeId"
            [animation]="techIcons?.animation">
          </shared-media-component-media>
        }
      </div>
      <div class="header hmf-display-flex hmf-justify-content-center" [innerHTML]="techIcons?.headline | bypassSanitization"></div>
      @if (techIcons?.subCopy !== undefined) {
        <div class="meta hmf-display-flex hmf-justify-content-center" [innerHTML]="techIcons?.subCopy | bypassSanitization"></div>
      }
    </div>
  }
</div>
